import { render, staticRenderFns } from "./OrderStatusHistoryPage.vue?vue&type=template&id=621ff246&scoped=true"
import script from "./OrderStatusHistoryPage.vue?vue&type=script&lang=js"
export * from "./OrderStatusHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./OrderStatusHistoryPage.vue?vue&type=style&index=0&id=621ff246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621ff246",
  null
  
)

export default component.exports